import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { ChatMap } from 'tripPlanner/components/ChatMap'
import type { ChatMapMarker } from 'tripPlanner/components/ChatMap/types'
import { useMapInteractionStyle } from '../contexts/MapInteractionContext'

export const DRAWER_DETAIL_MAP_HEIGHT_MOBILE_PX = 260
export const DRAWER_DETAIL_MAP_HEIGHT_DESKTOP_PX = 400

export const DrawerDetailMapFrame = styled.div`
  position: relative;
  width: 100%;
  height: ${rem(DRAWER_DETAIL_MAP_HEIGHT_MOBILE_PX)};
  border-radius: ${props => props.theme.borderRadius.L};
  overflow: hidden;

  ${mediaQueryUp.tablet} {
    height: ${rem(DRAWER_DETAIL_MAP_HEIGHT_DESKTOP_PX)};
  }
`

interface Props {
  markers: Array<ChatMapMarker>
  initialCenterPlaceId: string
  onEnlarge?: () => void
}

function DrawerDetailMap({ markers, initialCenterPlaceId, onEnlarge }: Props) {
  const { mapStyleMode, onMapStyleModeChange } = useMapInteractionStyle()

  return (
    <DrawerDetailMapFrame data-testid="drawer-detail-map-frame">
      <ChatMap
        markers={markers}
        initialCenterPlaceId={initialCenterPlaceId}
        scrollZoom={false}
        showAttributionControl={false}
        mapStyleMode={mapStyleMode}
        onMapStyleModeChange={onMapStyleModeChange}
        onEnlarge={onEnlarge}
      />
    </DrawerDetailMapFrame>
  )
}

export default DrawerDetailMap
